import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import webinarLogo from "@/assets/webinar-logo.jpeg";
import chart1 from "@/assets/chart-1-solbtc.jpeg";
import chart2 from "@/assets/chart-2-soleth.jpg";
import chart3 from "@/assets/chart-3-paalusdt.jpeg";

const Webinar = () => {
  const [selectedChart, setSelectedChart] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-blue-50 to-purple-50">
      {/* Header */}
      <header className="py-8 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex justify-center">
            <img 
              src={webinarLogo} 
              alt="GridBot DeFi Mastery" 
              className="w-full max-w-md object-contain"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto max-w-7xl px-4 py-8">
        {/* Webinar Info */}
        <div className="text-center mb-12">
          <p className="text-sm md:text-base text-slate-600 mb-6 uppercase tracking-wide">
            LIVE WEBINAR | DECEMBER 3, 2025 | 7PM GMT+3
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          {/* Left Column - Content */}
          <div className="max-w-sm">
            <h1 className="text-4xl md:text-6xl font-bold text-blue-900 mb-8 leading-tight">
              Set Up Your First Grid Trading Bot & Earn Bitcoin Yield in 60 Minutes
            </h1>

            <div className="space-y-8 mb-8">
              <div className="flex items-start gap-3">
                <span className="text-blue-900 text-2xl mt-1">•</span>
                <p className="text-slate-700 text-xl md:text-2xl">
                  Watch me configure a live grid bot from scratch
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-blue-900 text-2xl mt-1">•</span>
                <p className="text-slate-700 text-xl md:text-2xl">
                  The system that generated $184K+ bot profit from 2021-2025 (surviving the worst crypto bear market)
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-blue-900 text-2xl mt-1">•</span>
                <p className="text-slate-700 text-xl md:text-2xl">
                  See exactly what exchanges, tools, and settings to use
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-blue-900 text-2xl mt-1">•</span>
                <p className="text-slate-700 text-xl md:text-2xl">
                  Get the roadmap: What to set up before your first bot
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-blue-900 text-2xl mt-1">•</span>
                <p className="text-slate-700 text-xl md:text-2xl">
                  Register now – webinar starts December 3rd
                </p>
              </div>
            </div>

            <div className="flex justify-center">
              <a href="https://gridbot-defi-mastery.outseta.com/forms/496vwr9X" target="_blank" rel="noopener noreferrer">
                <Button 
                  className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-16 py-6 text-lg rounded-lg shadow-lg hover:shadow-xl transition-all duration-200"
                >
                  Register Now
                </Button>
              </a>
            </div>
          </div>

          {/* Right Column - Charts */}
          <div className="space-y-4">
            <div 
              className="rounded-lg overflow-hidden shadow-lg cursor-pointer group"
              onClick={() => setSelectedChart(chart1)}
            >
              <img 
                src={chart1} 
                alt="Grid Bot Trading Chart 1" 
                className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
              />
            </div>
            <div 
              className="rounded-lg overflow-hidden shadow-lg cursor-pointer group"
              onClick={() => setSelectedChart(chart2)}
            >
              <img 
                src={chart2} 
                alt="Grid Bot Trading Chart 2" 
                className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
              />
            </div>
            <div 
              className="rounded-lg overflow-hidden shadow-lg cursor-pointer group"
              onClick={() => setSelectedChart(chart3)}
            >
              <img 
                src={chart3} 
                alt="Grid Bot Trading Chart 3" 
                className="w-full h-auto transition-transform duration-300 group-hover:scale-110"
              />
            </div>
          </div>
        </div>

      </main>

      {/* Image Dialog */}
      <Dialog open={!!selectedChart} onOpenChange={() => setSelectedChart(null)}>
        <DialogContent className="max-w-6xl w-full max-h-[90vh] p-2 bg-black border-black">
          <div className="relative w-full h-full flex items-center justify-center">
            {selectedChart && (
              <img
                src={selectedChart}
                alt="Trading Chart Enlarged"
                className="max-w-full max-h-full object-contain"
              />
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Footer */}
      <footer className="text-center py-8 border-t border-slate-200">
        <p className="text-slate-500 text-sm">Powered by Leadpages</p>
      </footer>
    </div>
  );
};

export default Webinar;
